import React from 'react';

import { useTranslation } from '@crehana/i18n';

import Coupon from 'Jsx/CheckoutV4/components/Coupon';
import QuickEnroll from 'Jsx/CheckoutV4/components/QuickEnroll';
import PaymentMethodsSection from 'Jsx/CheckoutV4/components/PaymentMethodsSection';
import PromotionMessage from 'Jsx/CheckoutV4/components/PromotionMessage';
import GuaranteeShort from 'Jsx/CheckoutV4/components/Legals/Guarantee/GuaranteeShort';

import Legals from 'Jsx/CheckoutV4/components/Legals';

import { useCheckoutContext } from '../../Context';

import { PageProps } from '..';

import Header from './components/Header';
import PurchaseDetailThemeB from './components/PurchaseDetail/PurchaseDetailThemeB';

const CheckoutMobile: React.FC<PageProps> = ({
  setSelectedQuotaNumber,
  selectedQuotaNumber,
  displayTimer,
  selectedQuota,
  quotas,
  isCallCenter,
}) => {
  const { t } = useTranslation();
  const {
    isGuestCheckout,
    checkoutProductDetail,
    paymentMethods,
    checkoutProductsList,
    productData,
    handleApplyCoupon,
    handleRemoveCoupon,
    isQuickEnrollEnabled,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
  } = useCheckoutContext();

  const { isCouponEnabled, callCenter, pageCoupon } = productData;

  if (!checkoutProductDetail) return <div />;

  const backToMethods = () => {
    if (selectedPaymentMethod) {
      setSelectedPaymentMethod(undefined);
    } else {
      window.history.back();
    }
  };
  const showCampaignInfo =
    !isCallCenter && checkoutProductDetail?.type !== 'degree';

  return (
    <div className="h-screen overflow-x-hidden bg-gray-light">
      <Header onClick={backToMethods} />

      <div className="p-16 bg-white mx-8 my-8" style={{ borderRadius: 10 }}>
        <GuaranteeShort
          text={
            checkoutProductDetail.type === 'membership'
              ? t('MS_GUARANTEE_SHORT')
              : t('PAYG_GUARANTEE_SHORT')
          }
        />
      </div>

      {displayTimer && !callCenter?.isValidDuringCall && !showCampaignInfo && (
        <PromotionMessage
          className="flex bg-white mx-8 mb-8"
          message={`${t('TIMER_LABEL')} ${displayTimer}`}
        />
      )}
      {callCenter?.isValidDuringCall && !showCampaignInfo && (
        <PromotionMessage
          className="flex bg-white mx-8 mb-8"
          message={t('PROMOTION_MESSAGE')}
        />
      )}
      {isQuickEnrollEnabled ? (
        <div className="mx-8 bg-white p-16 mb-8" style={{ borderRadius: 10 }}>
          <QuickEnroll isGuestCheckout={isGuestCheckout} />
        </div>
      ) : (
        <div
          className="relative p-16 bg-white mx-8"
          style={{ borderRadius: 10 }}
        >
          <PaymentMethodsSection
            paymentMethods={paymentMethods}
            isMarketProduct={checkoutProductDetail.type === 'product'}
            isQuickEnrollEnabled={isQuickEnrollEnabled}
            isGuestCheckout={isGuestCheckout}
            symbol={checkoutProductDetail.codeSymbol}
            quotas={quotas}
            selectedQuotaNumber={selectedQuotaNumber}
            setSelectedQuotaNumber={setSelectedQuotaNumber}
          />
        </div>
      )}

      <div className="m-8 p-24 bg-white" style={{ borderRadius: 10 }}>
        <PurchaseDetailThemeB
          checkoutProductDetail={checkoutProductDetail}
          productsList={checkoutProductsList}
          selectedQuota={selectedQuota}
        />
      </div>

      {isCouponEnabled && (
        <div className="mx-8 bg-white p-16 mb-8" style={{ borderRadius: 10 }}>
          <Coupon
            handleApplyCoupon={handleApplyCoupon}
            handleRemoveCoupon={handleRemoveCoupon}
            couponCode={checkoutProductDetail.couponCode}
            canApplyCouponOnfirstRender={pageCoupon?.isValid}
          />
        </div>
      )}
      {/* Mobile footer */}
      <div className="my-40 px-8">
        <Legals
          itemType={checkoutProductDetail.type}
          totalToPayInDollars={
            (selectedQuota?.usdAmountPerQuota ||
              checkoutProductDetail?.totalToPay) as number
          }
        />
      </div>
    </div>
  );
};

export default CheckoutMobile;
